import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import MainPageLayout from "../../../layout/MainPageLayout";
import {
  PENDING_VHEICLE_READINGS,
  CHECK_VHEICLE_READINGS,
} from "../apiEndPoints";
import useGetHistory from "../../../CustomHooks/useAxios/useGetHistory";
import DialogBox from "../../../components/UI/DialogBox";
import { handleErrMessage } from "../../../functions/handleErrMessage";
import { setError } from "../../../redux/dataSlice";
import LoadingDisplay from "../../../components/UI/LoadingDisplay";
import { VehicleReadingTable } from "../components/vehicleReadingList/VehicleReadingTable";
import SearchTable from "../../../components/common/SearchTable";
import {
  VEHICLE_READING_SEARCH_OPTIONS,
  VEHICLE_PENDING_READING_FILTERS_OPTIONS,
} from "../utils/complaintFilter.config";
import { PENDING_VEHICLE_READING_COLUMNS } from "../utils/ComplaintsTables.config";
import VehicleReadingDialog from "../components/dialogs/VehicleReadingDialog";
import usePostData from "../../../CustomHooks/useAxios/usePostData";
import { ConfirmCheckReading } from "../components/vehicleReadingList/ConfirmCheckReading";
import FilterData from "../../../components/Filter/FilterData";

export const PendingVehicleReadingsPage = () => {
  const [openDialog, setOpenDialog] = useState({ openView: false });
  const [confirmType, setConfirmType] = useState(null);
  const { getHistory, historyLoaded, isSucceed } = useGetHistory();
  const { executePost, loading, successResponse, formError, setFormError } =
    usePostData();
  const dispatch = useDispatch();

  const data = useSelector((state) => state.data.data);
  const originalData = useSelector((state) => state.data.copyData);
  const historyError = useSelector((state) => state.data.error);
  const historyErrMsg = useSelector((state) => state.data.errMessage);
  const dataLength =
    !historyLoaded && !historyErrMsg && isSucceed ? data.length : 0;

  // API - for get pending vehicles readings
  useEffect(() => {
    getHistory(PENDING_VHEICLE_READINGS);
  }, []);

  // API - for check pending vehicle readings
  const checkVehicleReading = () => {
    const bodyData = { id: openDialog.data.id, status: confirmType };
    executePost(bodyData, CHECK_VHEICLE_READINGS);
  };

  const tableHeight =
    originalData.length > 0
      ? "h-[calc(100vh-8em)] max-lg:h-[calc(100vh-7em)] max-md:h-[calc(100vh-6em)]"
      : "h-[calc(100vh-5em)]";

  return (
    <MainPageLayout
      headerConfig={{ title: "Pending Vehicle Readings" }}
      numberOfData={dataLength}
      bgColor="bg-[#f0f2f7]"
    >
      {historyLoaded ? (
        <LoadingDisplay height="h-[80vh] mt-2" />
      ) : (
        isSucceed && (
          <>
            {originalData.length !== 0 && (
              <div className="pt-2 flex">
                <SearchTable
                  searchCategories={VEHICLE_READING_SEARCH_OPTIONS}
                  placeholder="Search by vehicle"
                />
                <FilterData
                  categories={VEHICLE_PENDING_READING_FILTERS_OPTIONS}
                />
              </div>
            )}
            <VehicleReadingTable
              columns={PENDING_VEHICLE_READING_COLUMNS}
              tableHeight={tableHeight}
              setOpenDialog={setOpenDialog}
            />
          </>
        )
      )}
      {historyError && (
        <DialogBox
          title="Error"
          btnText="Ok"
          message={handleErrMessage(historyErrMsg)}
          closeAction={() => dispatch(setError("false"))}
        />
      )}
      {/* // DIALOG - For view vehicle reading deyails */}
      {openDialog.openView && (
        <VehicleReadingDialog
          details={openDialog.data}
          closeDialog={() => setOpenDialog({ openView: false })}
          setConfirmType={setConfirmType}
          checkReading={true}
        />
      )}
      {/* // CONFIRM  DIALOG - to check vehicle reading */}
      {confirmType !== null && (
        <ConfirmCheckReading
          loading={loading}
          successResponse={successResponse}
          formError={formError}
          setFormError={setFormError}
          confirmType={confirmType}
          setConfirmType={setConfirmType}
          vehicleDetails={openDialog.data}
          checkVehicleReading={checkVehicleReading}
        />
      )}
    </MainPageLayout>
  );
};
